import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/by/personaFi/agent")({
  beforeLoad: () => {
    throw redirect({ to: "/by/agent", replace: true });
  },
});
